import { Alert, Input, Table } from "antd";
import usePendingRequests from "./logic/usePendingRequests";

// import "./PendingRequestsManagement.scss";

const PendingRequests = () => {
  const {
    requests,
    isFetching,
    error,
    columns,
    onChange,
    rowClassName,
    handleSearchChange,
  } = usePendingRequests();

  return (
    <div className="role-container">
        <Input.Search
          placeholder="Search..."
          onChange={handleSearchChange}
          style={{ width: "300px" }}
          className="search-input"
        />
      <div className="requests-content-container">
        {error ? (
          <Alert message="An error has occurred" type="error" showIcon />
        ) : (
          <>
            <Table
              columns={columns}
              dataSource={requests.data}
              onChange={onChange}
              loading={isFetching}
              pagination={{
                pageSize: requests.meta?.take,
                total: requests.meta?.itemCount,
                current: requests.meta?.page,
              }}
              rowClassName={rowClassName}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default PendingRequests;